import { configureStore } from '@reduxjs/toolkit';
import boardIdReducer from './Slices/boardIdSlice.js';
import modalReducer from './Slices/modalSlice';
import snackbarReducer from './Slices/snackbarSlice.js';
import usersReducer from './Slices/usersSlice';
import userReducer from './Slices/userSlice';
import boardMembersReducer from './Slices/boardMembersSlice.js';
import cardMemberReducer from './Slices/cardMemberSlice.js';
import workspaceReducer from './Slices/workspaceSlice.js';
import boardReducer from './Slices/boardSlice.js';
import boardsReducer from './Slices/boardsSlice.js';
import popoverReducer from './Slices/popoverSlice.js';
import checklistReducer from './Slices/checklistSlice.js';
import attachmentReducer from './Slices/attachmentSlice.js';
import labelReducer from './Slices/labelSlice.js';
import memberReducer from './Slices/memberSlice.js';
import cardReducer from './Slices/cardSlice.js';
import mentionedReducer from './Slices/mentionedSlice.js';
import filterQueryReducer from './Slices/filterQuerySlice.js';
import actionListReducer from './Slices/actionlistSlice.js';
import cardsByMemberIdReducer from './Slices/cardByMemberIdSlice.js';
import activitiesReducer from './Slices/activitiesSlice.js';
import moveCardReducer from './Slices/moveCardSlice.js';
import timerReducer from './Slices/timerSlice.js';
import analyticsReducer from './Slices/analyticsSlice.js';
import boardContextReducer from './Slices/boardContextSlice.js';
import expandableColumnReducer from './Slices/expandableColumnSlice.js';
import pageReducer from './Slices/pageSlice.js';
import templateReducer from './Slices/templateSlice.js';
import pageCommentsReducer from './Slices/pageCommentsSlice.js';
import automationReducer from './Slices/automationSlice.js';
import todayTaskReducer from './Slices/todayTaskSlice.js';
import customFieldsReducer from './Slices/customFieldsSlice.js';
import savedFiltersReducer from './Slices/savedFiltersSlice.js';

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['popover.props', 'popover.popovers'],
        ignoredActions: ['popover/togglePopover', 'popover/updatePopoverProps'],
      },
    }),
  reducer: {
    boardId: boardIdReducer,
    modal: modalReducer,
    snackbar: snackbarReducer,
    users: usersReducer,
    user: userReducer,
    cardMembers: cardMemberReducer,
    boardMembers: boardMembersReducer,
    workspaces: workspaceReducer,
    board: boardReducer,
    boards: boardsReducer,
    popover: popoverReducer,
    checklists: checklistReducer,
    attachments: attachmentReducer,
    labels: labelReducer,
    member: memberReducer,
    card: cardReducer,
    mentioned: mentionedReducer,
    filterQuery: filterQueryReducer,
    actionList: actionListReducer,
    cardsByMemberId: cardsByMemberIdReducer,
    activities: activitiesReducer,
    moveCard: moveCardReducer,
    timer: timerReducer,
    analytics: analyticsReducer,
    boardContext: boardContextReducer,
    expandableColumn: expandableColumnReducer,
    pages: pageReducer,
    templates: templateReducer,
    pageComments: pageCommentsReducer,
    automations: automationReducer,
    todayTask: todayTaskReducer,
    customFields: customFieldsReducer,
    savedFilters: savedFiltersReducer

    // Add other reducers as needed
  },
});

export default store;
